import React, { useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";

const ConsultaAsistencias = () => {
  const [filtros, setFiltros] = useState({
    cadeteDni: "",
    fechaDesde: "",
    fechaHasta: "",
    tipo: "Todos",
    estado: "Todos",
    lectorId: "",
  });

  const [resultado, setResultado] = useState(null);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState("");

  const API =
    "https://wwwa.isepsantafe.net.ar/expedientes/cadetes/consultarAsistencias";

  const tiposAsistencia = [
    "Todos",
    "Regular",
    "Fuera de Parte",
    "Pase Salida",
    "Otros",
    "Guardia Prevencion",
    "Demora Pase de Salida",
  ];

  const estados = [
    "Todos",
    "Activo",
    "Desactivado",
  ];

  // ============================================================
  // CAMBIO DE FILTROS
  // ============================================================

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFiltros((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // ============================================================
  // CONSULTAR
  // ============================================================

  const consultar = async () => {
    try {
      setCargando(true);
      setError("");

      const body = {};

      if (filtros.cadeteDni.trim()) {
        body.cadeteDni =
          filtros.cadeteDni.trim();
      }

      if (filtros.fechaDesde) {
        body.fechaDesde =
          filtros.fechaDesde;
      }

      if (filtros.fechaHasta) {
        body.fechaHasta =
          filtros.fechaHasta;
      }

      if (filtros.tipo !== "Todos") {
        body.tipo = filtros.tipo;
      }

      if (filtros.estado !== "Todos") {
        body.estado = filtros.estado;
      }

      if (filtros.lectorId.trim()) {
        body.lectorId =
          filtros.lectorId.trim();
      }

      console.log(
        "📤 Consultando asistencias:",
        body
      );

      const response =
        await axios.post(API, body);

      console.log(
        "📥 Resultado:",
        response.data
      );

      if (response.data?.success) {
        setResultado(response.data);
      } else {
        setResultado(null);

        setError(
          response.data?.message ||
            "No se pudieron obtener las asistencias."
        );
      }
    } catch (err) {
      console.error(
        "💥 Error consultando asistencias:",
        err
      );

      setResultado(null);

      setError(
        err.response?.data?.message ||
          err.response?.data?.error ||
          "Ocurrió un error al consultar las asistencias."
      );
    } finally {
      setCargando(false);
    }
  };

  // ============================================================
  // LIMPIAR
  // ============================================================

  const limpiar = () => {
    setFiltros({
      cadeteDni: "",
      fechaDesde: "",
      fechaHasta: "",
      tipo: "Todos",
      estado: "Todos",
      lectorId: "",
    });

    setResultado(null);
    setError("");
  };

  // ============================================================
  // NOMBRE COMPLETO
  // ============================================================

  const nombreCompleto = (item) => {
    return `${
      item.cadeteApellido || ""
    } ${
      item.cadeteNombre || ""
    }`.trim();
  };

  // ============================================================
  // DESCARGAR EXCEL
  // ============================================================

  const descargarExcel = () => {
    try {
      if (
        !resultado?.asistencias ||
        resultado.asistencias.length === 0
      ) {
        alert(
          "No hay asistencias para exportar."
        );

        return;
      }

      // ========================================================
      // DATOS PRINCIPALES
      // ========================================================

      const datosExcel =
        resultado.asistencias.map(
          (item, index) => ({
            Nro: index + 1,

            Fecha:
              item.fecha || "",

            Hora:
              item.hora || "",

            DNI:
              item.cadeteDni || "",

            Apellido:
              item.cadeteApellido || "",

            Nombre:
              item.cadeteNombre || "",

            Condicion:
              item.cadeteCondicion || "",

            EstadoCadete:
              item.cadeteEstado || "",

            Sede:
              item.cadeteSede || "",

            Seccion:
              item.seccionNombre || "",

            Compania:
              item.companiaNombre || "",

            TipoAsistencia:
              item.tipo || "",

            EstadoAsistencia:
              item.estado || "",

            Lector:
              item.lector || "",

            LectorID:
              item.lectorId || "",
          })
        );

      // ========================================================
      // HOJA ASISTENCIAS
      // ========================================================

      const hojaAsistencias =
        XLSX.utils.json_to_sheet(
          datosExcel
        );

      hojaAsistencias["!cols"] = [
        { wch: 6 },
        { wch: 12 },
        { wch: 10 },
        { wch: 12 },
        { wch: 22 },
        { wch: 22 },
        { wch: 16 },
        { wch: 16 },
        { wch: 16 },
        { wch: 18 },
        { wch: 18 },
        { wch: 24 },
        { wch: 18 },
        { wch: 25 },
        { wch: 10 },
      ];

      if (datosExcel.length > 0) {
        hojaAsistencias[
          "!autofilter"
        ] = {
          ref: `A1:O${
            datosExcel.length + 1
          }`,
        };
      }

      // ========================================================
      // HOJA RESUMEN
      // ========================================================

      const resumenExcel = [
        {
          Concepto: "Total",
          Cantidad:
            resultado.resumen
              ?.cantidad || 0,
        },
        {
          Concepto:
            "Regulares",
          Cantidad:
            resultado.resumen
              ?.regulares || 0,
        },
        {
          Concepto:
            "Fuera de Parte",
          Cantidad:
            resultado.resumen
              ?.fueraDeParte || 0,
        },
        {
          Concepto:
            "Guardia Prevención",
          Cantidad:
            resultado.resumen
              ?.guardiaPrevencion || 0,
        },
        {
          Concepto:
            "Pase de Salida",
          Cantidad:
            resultado.resumen
              ?.paseSalida || 0,
        },
        {
          Concepto:
            "Demora Pase de Salida",
          Cantidad:
            resultado.resumen
              ?.demoraPaseSalida || 0,
        },
        {
          Concepto: "Otros",
          Cantidad:
            resultado.resumen
              ?.otros || 0,
        },
        {
          Concepto: "Activos",
          Cantidad:
            resultado.resumen
              ?.activos || 0,
        },
        {
          Concepto:
            "Desactivados",
          Cantidad:
            resultado.resumen
              ?.desactivados || 0,
        },
      ];

      const hojaResumen =
        XLSX.utils.json_to_sheet(
          resumenExcel
        );

      hojaResumen["!cols"] = [
        { wch: 30 },
        { wch: 15 },
      ];

      // ========================================================
      // HOJA FILTROS
      // ========================================================

      const filtrosExcel = [
        {
          Filtro: "DNI",
          Valor:
            filtros.cadeteDni ||
            "Todos",
        },
        {
          Filtro: "Desde",
          Valor:
            filtros.fechaDesde ||
            "Sin límite",
        },
        {
          Filtro: "Hasta",
          Valor:
            filtros.fechaHasta ||
            "Sin límite",
        },
        {
          Filtro: "Tipo",
          Valor:
            filtros.tipo ||
            "Todos",
        },
        {
          Filtro: "Estado",
          Valor:
            filtros.estado ||
            "Todos",
        },
        {
          Filtro: "Lector ID",
          Valor:
            filtros.lectorId ||
            "Todos",
        },
      ];

      const hojaFiltros =
        XLSX.utils.json_to_sheet(
          filtrosExcel
        );

      hojaFiltros["!cols"] = [
        { wch: 20 },
        { wch: 30 },
      ];

      // ========================================================
      // CREAR LIBRO
      // ========================================================

      const workbook =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        hojaAsistencias,
        "Asistencias"
      );

      XLSX.utils.book_append_sheet(
        workbook,
        hojaResumen,
        "Resumen"
      );

      XLSX.utils.book_append_sheet(
        workbook,
        hojaFiltros,
        "Filtros"
      );

      // ========================================================
      // NOMBRE ARCHIVO
      // ========================================================

      let nombreArchivo =
        "Asistencias_ISeP";

      if (filtros.cadeteDni) {
        nombreArchivo +=
          `_DNI_${filtros.cadeteDni}`;
      }

      if (filtros.fechaDesde) {
        nombreArchivo +=
          `_desde_${filtros.fechaDesde}`;
      }

      if (filtros.fechaHasta) {
        nombreArchivo +=
          `_hasta_${filtros.fechaHasta}`;
      }

      nombreArchivo += ".xlsx";

      // ========================================================
      // DESCARGAR
      // ========================================================

      XLSX.writeFile(
        workbook,
        nombreArchivo
      );
    } catch (error) {
      console.error(
        "Error generando Excel:",
        error
      );

      alert(
        "No se pudo generar el archivo Excel."
      );
    }
  };

  // ============================================================
  // RENDER
  // ============================================================

  return (
    <div style={styles.page}>
      <div style={styles.container}>

        {/* =================================================== */}
        {/* CABECERA */}
        {/* =================================================== */}

        <div style={styles.header}>
          <div>
            <div style={styles.headerLabel}>
              ISeP
            </div>

            <h1 style={styles.title}>
              Consulta de Asistencias
            </h1>

            <p style={styles.subtitle}>
              Consulta histórica de registros
              de ingreso y asistencia
            </p>
          </div>

          {resultado && (
            <div style={styles.totalHeader}>
              <span
                style={
                  styles.totalNumero
                }
              >
                {resultado.cantidad || 0}
              </span>

              <span
                style={
                  styles.totalTexto
                }
              >
                registros
              </span>
            </div>
          )}
        </div>

        {/* =================================================== */}
        {/* FILTROS */}
        {/* =================================================== */}

        <div style={styles.card}>
          <div style={styles.cardHeader}>
            <div>
              <h2
                style={
                  styles.cardTitle
                }
              >
                Filtros de búsqueda
              </h2>

              <p
                style={
                  styles.cardSubtitle
                }
              >
                Podés utilizar uno o varios
                criterios
              </p>
            </div>
          </div>

          <div
            style={
              styles.filtersGrid
            }
          >
            {/* DNI */}

            <div style={styles.field}>
              <label style={styles.label}>
                DNI
              </label>

              <input
                type="number"
                name="cadeteDni"
                value={
                  filtros.cadeteDni
                }
                onChange={
                  handleChange
                }
                placeholder="Ej: 36860924"
                style={styles.input}
              />
            </div>

            {/* DESDE */}

            <div style={styles.field}>
              <label style={styles.label}>
                Desde
              </label>

              <input
                type="date"
                name="fechaDesde"
                value={
                  filtros.fechaDesde
                }
                onChange={
                  handleChange
                }
                style={styles.input}
              />
            </div>

            {/* HASTA */}

            <div style={styles.field}>
              <label style={styles.label}>
                Hasta
              </label>

              <input
                type="date"
                name="fechaHasta"
                value={
                  filtros.fechaHasta
                }
                onChange={
                  handleChange
                }
                style={styles.input}
              />
            </div>

            {/* TIPO */}

            <div style={styles.field}>
              <label style={styles.label}>
                Tipo
              </label>

              <select
                name="tipo"
                value={filtros.tipo}
                onChange={
                  handleChange
                }
                style={styles.input}
              >
                {tiposAsistencia.map(
                  (tipo) => (
                    <option
                      key={tipo}
                      value={tipo}
                    >
                      {tipo}
                    </option>
                  )
                )}
              </select>
            </div>

            {/* ESTADO */}

            <div style={styles.field}>
              <label style={styles.label}>
                Estado
              </label>

              <select
                name="estado"
                value={
                  filtros.estado
                }
                onChange={
                  handleChange
                }
                style={styles.input}
              >
                {estados.map(
                  (estado) => (
                    <option
                      key={estado}
                      value={estado}
                    >
                      {estado}
                    </option>
                  )
                )}
              </select>
            </div>

            {/* LECTOR */}

            <div style={styles.field}>
              <label style={styles.label}>
                ID lector
              </label>

              <input
                type="number"
                name="lectorId"
                value={
                  filtros.lectorId
                }
                onChange={
                  handleChange
                }
                placeholder="Opcional"
                style={styles.input}
              />
            </div>
          </div>

          {/* ================================================= */}
          {/* BOTONES */}
          {/* ================================================= */}

          <div style={styles.buttons}>
            <button
              onClick={consultar}
              disabled={cargando}
              style={{
                ...styles.btnPrimary,
                opacity:
                  cargando
                    ? 0.65
                    : 1,
              }}
            >
              {cargando
                ? "Consultando..."
                : "Buscar asistencias"}
            </button>

            <button
              onClick={limpiar}
              style={
                styles.btnSecondary
              }
            >
              Limpiar
            </button>

            {resultado
              ?.asistencias
              ?.length > 0 && (
              <button
                onClick={
                  descargarExcel
                }
                style={
                  styles.btnExcel
                }
              >
                ↓ Descargar Excel
              </button>
            )}
          </div>
        </div>

        {/* =================================================== */}
        {/* ERROR */}
        {/* =================================================== */}

        {error && (
          <div style={styles.error}>
            {error}
          </div>
        )}

        {/* =================================================== */}
        {/* RESULTADOS */}
        {/* =================================================== */}

        {resultado && (
          <>
            {/* ================================================= */}
            {/* RESUMEN */}
            {/* ================================================= */}

            <div
              style={
                styles.summaryGrid
              }
            >
              <Resumen
                titulo="Total"
                valor={
                  resultado.resumen
                    ?.cantidad || 0
                }
              />

              <Resumen
                titulo="Regulares"
                valor={
                  resultado.resumen
                    ?.regulares || 0
                }
              />

              <Resumen
                titulo="Fuera de Parte"
                valor={
                  resultado.resumen
                    ?.fueraDeParte || 0
                }
              />

              <Resumen
                titulo="Guardias"
                valor={
                  resultado.resumen
                    ?.guardiaPrevencion ||
                  0
                }
              />

              <Resumen
                titulo="Pase salida"
                valor={
                  resultado.resumen
                    ?.paseSalida || 0
                }
              />

              <Resumen
                titulo="Demoras"
                valor={
                  resultado.resumen
                    ?.demoraPaseSalida ||
                  0
                }
              />

              <Resumen
                titulo="Otros"
                valor={
                  resultado.resumen
                    ?.otros || 0
                }
              />

              <Resumen
                titulo="Activos"
                valor={
                  resultado.resumen
                    ?.activos || 0
                }
              />

              <Resumen
                titulo="Desactivados"
                valor={
                  resultado.resumen
                    ?.desactivados || 0
                }
              />
            </div>

            {/* ================================================= */}
            {/* TABLA */}
            {/* ================================================= */}

            <div style={styles.card}>
              <div
                style={
                  styles.cardHeader
                }
              >
                <div>
                  <h2
                    style={
                      styles.cardTitle
                    }
                  >
                    Resultados
                  </h2>

                  <p
                    style={
                      styles.cardSubtitle
                    }
                  >
                    {resultado.cantidad ===
                    1
                      ? "1 asistencia encontrada"
                      : `${
                          resultado.cantidad ||
                          0
                        } asistencias encontradas`}
                  </p>
                </div>

                {resultado
                  ?.asistencias
                  ?.length > 0 && (
                  <button
                    onClick={
                      descargarExcel
                    }
                    style={
                      styles.btnExcel
                    }
                  >
                    ↓ Excel
                  </button>
                )}
              </div>

              {!resultado
                .asistencias
                ?.length ? (
                <div
                  style={
                    styles.empty
                  }
                >
                  No se encontraron
                  asistencias con los
                  filtros seleccionados.
                </div>
              ) : (
                <div
                  style={
                    styles.tableWrapper
                  }
                >
                  <table
                    style={styles.table}
                  >
                    <thead>
                      <tr>
                        <th
                          style={
                            styles.th
                          }
                        >
                          Fecha
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Hora
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          DNI
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Cadete
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Sede
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Sección
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Compañía
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Tipo
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Estado
                        </th>

                        <th
                          style={
                            styles.th
                          }
                        >
                          Lector
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {resultado.asistencias.map(
                        (item) => (
                          <tr
                            key={
                              item.id
                            }
                            style={
                              styles.tr
                            }
                          >
                            <td
                              style={
                                styles.td
                              }
                            >
                              <strong>
                                {
                                  item.fecha
                                }
                              </strong>
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              {
                                item.hora
                              }
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              {
                                item.cadeteDni
                              }
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              <div
                                style={
                                  styles.nombre
                                }
                              >
                                {nombreCompleto(
                                  item
                                ) ||
                                  "Sin datos"}
                              </div>

                              {item.cadeteCondicion && (
                                <div
                                  style={
                                    styles.small
                                  }
                                >
                                  {
                                    item.cadeteCondicion
                                  }
                                </div>
                              )}
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              {item.cadeteSede ||
                                "-"}
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              {item.seccionNombre ||
                                "-"}
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              {item.companiaNombre ||
                                "-"}
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              <TipoBadge
                                tipo={
                                  item.tipo
                                }
                              />
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              <EstadoBadge
                                estado={
                                  item.estado
                                }
                              />
                            </td>

                            <td
                              style={
                                styles.td
                              }
                            >
                              <div>
                                {item.lector ||
                                  "-"}
                              </div>

                              {item.lectorId && (
                                <div
                                  style={
                                    styles.small
                                  }
                                >
                                  ID{" "}
                                  {
                                    item.lectorId
                                  }
                                </div>
                              )}
                            </td>
                          </tr>
                        )
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}

        {/* =================================================== */}
        {/* SIN CONSULTA */}
        {/* =================================================== */}

        {!resultado &&
          !error &&
          !cargando && (
            <div
              style={
                styles.initial
              }
            >
              <div
                style={
                  styles.initialIcon
                }
              >
                ⌕
              </div>

              <h3
                style={
                  styles.initialTitle
                }
              >
                Consulta histórica
              </h3>

              <p
                style={
                  styles.initialText
                }
              >
                Seleccioná un DNI,
                período o cualquier
                combinación de filtros
                y presioná Buscar
                asistencias.
              </p>
            </div>
          )}
      </div>
    </div>
  );
};

// ============================================================
// RESUMEN
// ============================================================

const Resumen = ({
  titulo,
  valor,
}) => {
  return (
    <div
      style={
        styles.summaryCard
      }
    >
      <div
        style={
          styles.summaryValue
        }
      >
        {valor}
      </div>

      <div
        style={
          styles.summaryLabel
        }
      >
        {titulo}
      </div>
    </div>
  );
};

// ============================================================
// BADGE TIPO
// ============================================================

const TipoBadge = ({ tipo }) => {
  let background =
    "#eef2f7";

  let color =
    "#344054";

  if (tipo === "Regular") {
    background =
      "#ecfdf3";

    color =
      "#027a48";
  }

  if (
    tipo === "Fuera de Parte"
  ) {
    background =
      "#fff4e5";

    color =
      "#b54708";
  }

  if (
    tipo ===
    "Guardia Prevencion"
  ) {
    background =
      "#eef4ff";

    color =
      "#3538cd";
  }

  if (
    tipo === "Pase Salida"
  ) {
    background =
      "#f4f3ff";

    color =
      "#5925dc";
  }

  if (
    tipo ===
    "Demora Pase de Salida"
  ) {
    background =
      "#fef3f2";

    color =
      "#b42318";
  }

  return (
    <span
      style={{
        ...styles.badge,
        background,
        color,
      }}
    >
      {tipo}
    </span>
  );
};

// ============================================================
// BADGE ESTADO
// ============================================================

const EstadoBadge = ({
  estado,
}) => {
  const activo =
    estado === "Activo";

  return (
    <span
      style={{
        ...styles.badge,

        background:
          activo
            ? "#ecfdf3"
            : "#f2f4f7",

        color:
          activo
            ? "#027a48"
            : "#667085",
      }}
    >
      {estado}
    </span>
  );
};

// ============================================================
// ESTILOS
// ============================================================

const styles = {
  page: {
    minHeight: "100vh",

    background:
      "#f4f7f9",

    padding:
      "28px 16px",

    fontFamily:
      "'Inter', 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  },

  container: {
    width: "100%",

    maxWidth:
      "1500px",

    margin:
      "0 auto",
  },

  header: {
    display:
      "flex",

    justifyContent:
      "space-between",

    alignItems:
      "center",

    marginBottom:
      "24px",

    gap:
      "20px",

    flexWrap:
      "wrap",
  },

  headerLabel: {
    fontSize:
      "12px",

    fontWeight:
      "800",

    textTransform:
      "uppercase",

    letterSpacing:
      "2px",

    color:
      "#3d7277",

    marginBottom:
      "5px",
  },

  title: {
    margin: 0,

    fontSize:
      "30px",

    fontWeight:
      "800",

    color:
      "#1d2939",
  },

  subtitle: {
    margin:
      "6px 0 0 0",

    color:
      "#667085",

    fontSize:
      "14px",
  },

  totalHeader: {
    display:
      "flex",

    flexDirection:
      "column",

    alignItems:
      "flex-end",
  },

  totalNumero: {
    fontSize:
      "30px",

    fontWeight:
      "800",

    color:
      "#315f64",

    lineHeight:
      1,
  },

  totalTexto: {
    fontSize:
      "12px",

    color:
      "#667085",

    marginTop:
      "4px",
  },

  card: {
    background:
      "#ffffff",

    borderRadius:
      "16px",

    padding:
      "22px",

    boxShadow:
      "0 3px 14px rgba(0,0,0,0.06)",

    border:
      "1px solid #eaecf0",

    marginBottom:
      "20px",
  },

  cardHeader: {
    display:
      "flex",

    alignItems:
      "center",

    justifyContent:
      "space-between",

    gap:
      "15px",

    marginBottom:
      "20px",

    flexWrap:
      "wrap",
  },

  cardTitle: {
    margin: 0,

    color:
      "#1d2939",

    fontSize:
      "18px",

    fontWeight:
      "700",
  },

  cardSubtitle: {
    margin:
      "4px 0 0 0",

    color:
      "#667085",

    fontSize:
      "13px",
  },

  filtersGrid: {
    display:
      "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(180px, 1fr))",

    gap:
      "15px",
  },

  field: {
    display:
      "flex",

    flexDirection:
      "column",

    gap:
      "6px",
  },

  label: {
    fontWeight:
      "600",

    color:
      "#344054",

    fontSize:
      "13px",
  },

  input: {
    width:
      "100%",

    boxSizing:
      "border-box",

    border:
      "1px solid #d0d5dd",

    borderRadius:
      "9px",

    padding:
      "10px 12px",

    fontSize:
      "14px",

    background:
      "#ffffff",

    color:
      "#101828",

    outline:
      "none",
  },

  buttons: {
    display:
      "flex",

    gap:
      "10px",

    marginTop:
      "20px",

    flexWrap:
      "wrap",
  },

  btnPrimary: {
    border:
      "none",

    borderRadius:
      "9px",

    padding:
      "11px 18px",

    background:
      "#315f64",

    color:
      "#ffffff",

    fontWeight:
      "700",

    cursor:
      "pointer",

    fontSize:
      "14px",
  },

  btnSecondary: {
    border:
      "1px solid #d0d5dd",

    borderRadius:
      "9px",

    padding:
      "11px 18px",

    background:
      "#ffffff",

    color:
      "#344054",

    fontWeight:
      "600",

    cursor:
      "pointer",

    fontSize:
      "14px",
  },

  btnExcel: {
    border:
      "1px solid #067647",

    borderRadius:
      "9px",

    padding:
      "11px 18px",

    background:
      "#ecfdf3",

    color:
      "#067647",

    fontWeight:
      "700",

    cursor:
      "pointer",

    fontSize:
      "14px",
  },

  summaryGrid: {
    display:
      "grid",

    gridTemplateColumns:
      "repeat(auto-fit, minmax(130px, 1fr))",

    gap:
      "12px",

    marginBottom:
      "20px",
  },

  summaryCard: {
    background:
      "#ffffff",

    border:
      "1px solid #eaecf0",

    borderRadius:
      "13px",

    padding:
      "16px",

    boxShadow:
      "0 2px 8px rgba(0,0,0,.04)",
  },

  summaryValue: {
    fontSize:
      "25px",

    fontWeight:
      "800",

    color:
      "#315f64",

    lineHeight:
      "1.1",
  },

  summaryLabel: {
    marginTop:
      "6px",

    color:
      "#667085",

    fontWeight:
      "600",

    fontSize:
      "12px",
  },

  tableWrapper: {
    overflowX:
      "auto",

    width:
      "100%",
  },

  table: {
    width:
      "100%",

    borderCollapse:
      "collapse",

    minWidth:
      "1050px",
  },

  th: {
    textAlign:
      "left",

    padding:
      "11px 10px",

    borderBottom:
      "1px solid #eaecf0",

    background:
      "#f9fafb",

    color:
      "#475467",

    fontSize:
      "11px",

    fontWeight:
      "700",

    textTransform:
      "uppercase",

    letterSpacing:
      ".3px",
  },

  tr: {
    borderBottom:
      "1px solid #f2f4f7",
  },

  td: {
    padding:
      "12px 10px",

    color:
      "#344054",

    fontSize:
      "13px",

    verticalAlign:
      "middle",
  },

  nombre: {
    fontWeight:
      "700",

    color:
      "#1d2939",
  },

  small: {
    fontSize:
      "11px",

    color:
      "#98a2b3",

    marginTop:
      "2px",
  },

  badge: {
    display:
      "inline-block",

    padding:
      "5px 9px",

    borderRadius:
      "20px",

    fontSize:
      "11px",

    fontWeight:
      "700",

    whiteSpace:
      "nowrap",
  },

  error: {
    padding:
      "14px 16px",

    borderRadius:
      "10px",

    background:
      "#fef3f2",

    border:
      "1px solid #fecdca",

    color:
      "#b42318",

    fontWeight:
      "600",

    marginBottom:
      "20px",
  },

  empty: {
    padding:
      "40px",

    textAlign:
      "center",

    color:
      "#667085",
  },

  initial: {
    background:
      "#ffffff",

    border:
      "1px dashed #cfd8dc",

    borderRadius:
      "16px",

    textAlign:
      "center",

    padding:
      "55px 20px",
  },

  initialIcon: {
    fontSize:
      "42px",

    color:
      "#527d81",

    marginBottom:
      "10px",
  },

  initialTitle: {
    color:
      "#344054",

    fontSize:
      "18px",

    margin:
      "0 0 7px",
  },

  initialText: {
    color:
      "#667085",

    fontSize:
      "14px",

    maxWidth:
      "500px",

    margin:
      "0 auto",

    lineHeight:
      "1.5",
  },
};

export default ConsultaAsistencias;